// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"ViewDivider_modal-scroll__NqVPv","container":"ViewDivider_container__h0BkT","div":"ViewDivider_div__NMSm_"};